export default __webpack_public_path__ + "static/media/Comp 2_00043.67ef22f9.png";